import { useEffect, useState } from 'react';
import { useNCZIContext } from '../Services/NCZIContext';
import useNCZICommands from './useNCZICommands';
import {
	GetPatientElectronicPrescriptionList,
	GetPatientElectronicPrescriptionListParams,
} from '../Commands/GetPatientElectronicPrescriptionList';
import apiClient from '../../../Services/ApiClient';
import { FinishedCommand } from '../Commands/Command';

export default function useNCZIElectronicPrescription() {
	const {
		patientElectronicPrescriptionData,
		setPatientElectronicPrescriptionData,
		patientBirthNumber,
		patientInsurance
	} = useNCZIContext();

	const { commands, execute } = useNCZICommands();

	const [
		listElectronicPrescriptionCommandId,
		setListElectronicPrescriptionCommandId,
	] = useState<string | undefined>(undefined);
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
		undefined,
	);

	const fetchPatientElectronicPrescriptionData = async (
		params: GetPatientElectronicPrescriptionListParams,
	) => {
		const command = await obtainPatientElectronicPrescriptionListData(params);
		setPatientElectronicPrescriptionData(null);
		return command;
	};

	useEffect(() => {
		if (
			listElectronicPrescriptionCommandId &&
			!patientElectronicPrescriptionData
		) {
			const command = commands[listElectronicPrescriptionCommandId];
			if (command && command.state === 'done') {
				const finishedCommand = command as FinishedCommand;
				if (finishedCommand.result) {
					setPatientElectronicPrescriptionData(finishedCommand.result);
				}
			}
		}
	}, [commands, listElectronicPrescriptionCommandId]);

	const obtainPatientElectronicPrescriptionListData = async (
		params: GetPatientElectronicPrescriptionListParams,
	) => {
		const commandGetPatientElectronicPrescriptionList =
			GetPatientElectronicPrescriptionList(params);

		const result = await execute(commandGetPatientElectronicPrescriptionList);
		if (!('error' in result && result.error)) {
			setListElectronicPrescriptionCommandId(result.id);
		}

		return result;
	};

	const handleLoadPatientElectronicPrescriptionData = async () => {
		if (patientBirthNumber && patientInsurance) {
			const command = await fetchPatientElectronicPrescriptionData({
				birthNumber: patientBirthNumber,
				insurance: patientInsurance
			});
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleFakeLoadPatientElectronicPrescriptionData = async () => {
		const { data: response } = await apiClient.get(
			'/nczi/message/a0242151-4834-437e-ba94-e26c53e5eb26/response',
		);
		setPatientElectronicPrescriptionData(response.data);
	};

	return {
		handleLoadPatientElectronicPrescriptionData,
		handleFakeLoadPatientElectronicPrescriptionData,
		loadingCommandId,
	};
}
